import { makeAutoObservable, reaction, runInAction } from 'mobx';

import { AreaUnit, Currency } from '../../graphql/graphql';
import { BaseRootStore } from '../rootStore/baseRootStore';

export default class AreaUnitStore<IRootStore extends BaseRootStore> {
  rootStore: IRootStore;

  areaUnit: AreaUnit = AreaUnit.Hectares;

  constructor(rootStore: IRootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;

    reaction(
      () => ({
        currency:
          this.rootStore.userStore.combinedData.stripeCustomer?.currency,
      }),
      ({ currency }) => {
        if (currency) {
          this.areaUnit =
            currency === Currency.Usd ? AreaUnit.Acres : AreaUnit.Hectares;
        }
      },
    );
  }

  reset() {
    runInAction(() => {
      this.areaUnit = AreaUnit.Hectares;
    });
  }

  setAreaUnit = (areaUnit: AreaUnit) => {
    this.areaUnit = areaUnit;
  };
}
